import { inject, Injectable } from '@angular/core';
import { ApiResultInterface, ApiService, RequestBuilder, RequestTypeEnum } from '@client-monorepo/common/network';
import { Observable } from 'rxjs';
import { RateableApiResponse, RateBody } from '@client-monorepo/common/rate';
import { StorageService } from '@client-monorepo/common/utilities';

@Injectable({
  providedIn: 'root',
})
export class RateApiService {
  apiService = inject(ApiService);
  storageService = inject(StorageService);

  public getAllRatables(): Observable<RateableApiResponse> {
    const request = new RequestBuilder(RequestTypeEnum.GET, `app/dpx/rate/rateable`);
    return this.apiService.call<RateableApiResponse>(request);
  }

  public postRate(body: RateBody): Observable<ApiResultInterface> {
    const request = new RequestBuilder(RequestTypeEnum.POST, `app/dpx/rate`, body);
    return this.apiService.call<ApiResultInterface>(request);
  }

  public postpone(uid: string, reasons: string[]): Observable<ApiResultInterface> {
    const request = new RequestBuilder(RequestTypeEnum.POST, `app/dpx/rate/postpone`, { uid, reasons });
    return this.apiService.call<ApiResultInterface>(request);
  }

  public ignore(uid: string, reasons: string[]): Observable<ApiResultInterface> {
    const request = new RequestBuilder(RequestTypeEnum.POST, `app/dpx/rate/ignore`, { uid, reasons });
    return this.apiService.call<ApiResultInterface>(request);
  }
}
